import { Component } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { MsalModule } from '@azure/msal-angular';

/**
 * AppComponent - Root component of the application
 */
@Component({
  selector: 'app-root',
  imports: [RouterOutlet, MsalModule],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
  host: {
    class: 'has-navbar-fixed-top si-layout-fixed-height'
  }
})
export class AppComponent {}
